import {
    UPDATE_CONTRACTOR_ENGINEER_REQUEST,
    UPDATE_CONTRACTOR_ENGINEER_SUCCESS,
    UPDATE_CONTRACTOR_ENGINEER_FAILURE,
    CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_REQUEST,
    CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_SUCCESS,
    CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_FAILURE,
    CONTRACTOR_ENGINEER_DOCUMENT_DELETE_REQUEST,
    CONTRACTOR_ENGINEER_DOCUMENT_DELETE_SUCCESS,
    CONTRACTOR_ENGINEER_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const CONTRACTOR_ENGINEER_INITIAL_STATE = {
    isFetching: false,
    isUploading: false,
    isRemoving: false,
    error: null,
    uploadError: null,
    removeError: null,
    documents: []
};

const engineerReducers = {
    [UPDATE_CONTRACTOR_ENGINEER_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [UPDATE_CONTRACTOR_ENGINEER_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null};
    },
    [UPDATE_CONTRACTOR_ENGINEER_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_REQUEST]: (state) => {
        return {...state, isUploading: true, uploadError: null};
    },
    [CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isUploading: false, uploadError: null};
    },
    [CONTRACTOR_ENGINEER_DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isUploading: false, uploadError: error};
    },
    [CONTRACTOR_ENGINEER_DOCUMENT_DELETE_REQUEST]: (state) => {
        return {...state, isRemoving: true, removeError: null};
    },
    [CONTRACTOR_ENGINEER_DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const documents = [...state.documents].filter(doc => doc.id !== docId);

        return {...state, documents, isRemoving: false, removeError: null}
    },
    [CONTRACTOR_ENGINEER_DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isRemoving: false, removeError: error};
    }
};

export default function engineers(state = CONTRACTOR_ENGINEER_INITIAL_STATE, action) {
    let reducer = engineerReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-engineer.js